module.exports = __webpack_public_path__ + "static/img/yg_btn2.e9f1048.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/yg_btn2.png
// module id = 7+xY
// module chunks = 7